import { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AppContext } from './context'
import { baseUrl, apiUrl } from './delcare'
import UiSpinner from './ui_spinner';
import UiButton3 from './ui_button3';
import UiInput1 from './ui_input1';
import moment from 'moment';
import BrandAuthViewLink from './brand_auth_view_link';
import BrandAuthViewStatus from './brand_auth_view_status';
import BrandAuthStatus from './brand_auth_status';
import UiTooltip from './ui_tooltip';

const BrandAuthView = () => {

	let navigate = useNavigate()
	let { id } = useParams()

	let [authorizedMarketPlace, setAuthorizedMarketplace] = useState({})
	let [loading, setLoading] = useState(false);
	let [errorMessage, setErrorMessage] = useState(false)
	const [message, setMessage] = useState("")
	const [tab, setTab] = useState("ppc")
	const [adType, setAdType] = useState("")
	const [sellerVendorList, setSellerVendorList] = useState([])
	const [selectedSellerVendor, setSelectedSellerVendor] = useState("")
	const [sellerVendorTable, setSellerVendorTable] = useState([])
	const [tableLoading, setTableLoading] = useState(false);
	const [search, setSearch] = useState("")
	const [clientAuthListLoaded, setClientAuthListLoaded] = useState(false)
	const [agencyLoaded, setAgencyLoaded] = useState(false)

	let {
		toastInit,
		setToastContent,
		token,
		neonUser,
		marketplaceList,
		getMarketPlace,
		setToDeleteProfile,
		offCanvas,
		setPopupSidebarType,
		setSideBarTitle,
		reloadProfileList, setReloadProfileList,
		hh, ww,
		updateChecklist,
		setBrand,
		userOwnsBrand,
		getAgencyClients,
		clientAuthList,
		getBrands,
		disposeAllTooltip,
		fetchDataV2,
		adsProfileIdsLoaded
	} = useContext(AppContext)

	const goBack = (e) => {
		e.preventDefault()
		navigate(-1)
	}

	const showErrorToast = (message, value) => {
		setLoading(false)
		setMessage(message)
		setToastContent(message)
		toastInit.show()
		return
	}

	const updateSellerVendor = async () => {
		setLoading(true)

		let query1 = "UPDATE_SELLER_VENDOR_1", params1 = [neonUser.agency_id]
		let query2 = "UPDATE_SELLER_VENDOR_2", params2 = [neonUser.agency_id]

		let ids = [], refresh_dates = []
		try {
			ids = await fetchDataV2(query1, params1, "/neon-market-v2")

			if (ids.length == 0) return

			let query3 = "UPDATE_SELLER_VENDOR_3", params3 = [ids.map(x => x.client_id)]
			let resp = await fetchDataV2(query3, params3, "/neon-market-v2")

			if (resp.length > 0) refresh_dates = resp
		}
		catch (err) {
			return
		}

		let deletedId = []
		try {
			deletedId = await fetchDataV2(query2, params2, "/neon-market-v2")
		}
		catch (err) {
			return
		}

		ids = ids.map(x => x.client_id)
		setSellerVendorList([])

		let updateAmazonData = async (client_id) => {
			let url = `${apiUrl}/amazon-all-refresh-token-v2?record_db=true&client_id=${client_id}&user_refresh=1`
			try {
				let resp2 = await fetch(url, {
					method: "GET",
					headers: (() => {
						const myHeaders = new Headers();
						myHeaders.append("Content-Type", "application/json");
						myHeaders.append("Authorization", `Bearer ${token.accessToken}`)
						return myHeaders
					})()
				})
				resp2 = await resp2.json()
			}
			catch (err) {
				return
			}

			let query4 = "UPDATE_SELLER_VENDOR_4", params4 = [client_id]
			await fetchDataV2(query4, params4, "/neon-market-v2")
			return
		}

		try {
			for (let i = 0; i < ids.length; i++) {
				await updateAmazonData(ids[i])

				let resp3 = await fetch(apiUrl + "/all_profiles_create?client_id=" + ids[i], {
					method: "POST",
					headers: (() => {
						const myHeaders = new Headers();
						myHeaders.append("Content-Type", "application/json");
						myHeaders.append("Authorization", `Bearer ${token.accessToken}`)
						return myHeaders
					})(),
					body: JSON.stringify({ client_id: Number(ids[i]) }),
				})

				if (!resp3.ok) continue;

				resp3 = await resp3.text()

				await new Promise(resolve => {
					setTimeout(async () => {
						await getSellerVendorList()
						resolve()
					}, 1000)
				})
			}
			setMessage("Profile list updated.")
			setToastContent("Profile list updated.")
			toastInit.show()
			return
		}
		catch (err) {
			showErrorToast("Something went wrong. Please try again or contact support.", err)
			return
		}
		finally {
			setLoading(false)
		}
	}

	const getAuthorizedMarketplace = async () => {
		let query1 = "GET_AUTHORIZED_PROFILES_1", params1 = [id]
		let resp = await fetchDataV2(query1, params1, "/neon-query-v2")

		if (resp.length == 0) {
			navigate("/brand");
			return
		}

		let query2 = "GET_AUTHORIZED_PROFILES_2", params2 = [resp[0].brand_int_id]
		let brand = await fetchDataV2(query2, params2, "/neon-query-v2")
		setBrand(brand[0])

		let query3 = "GET_AUTHORIZED_PROFILES_3", params3 = [
			resp[0].brand_entity_id,
			resp[0].account_type == 'seller' ? 'seller_central' : resp[0].account_type == 'vendor' ? 'vendor_central' : resp[0].account_type,
			marketplaceList.filter(x => x.id == resp[0].marketplace_id)[0].marketplaceid
		]
		let resp2 = await fetchDataV2(query3, params3, "/neon-market-v2")

		let query4 = "GET_AUTHORIZED_PROFILES_4", params4 = [id]
		let resp3 = await fetchDataV2(query4, params4, "/neon-query-v2")

		resp = {
			...resp[0],
			profile: resp2[0] || {},
		}

		resp = {
			...resp,
			marketPlace: marketplaceList.filter(x => Number(x.id) == Number(resp.marketplace_id))[0],
			brand_marketplace: resp3[0] || {},
			auth_error: (() => {
				// console.log("CLIENT AUTH LIST",clientAuthList.filter(xx => !xx.status))
				let list = clientAuthList.filter(xx => !xx.status).map(xx => xx.client_info_id)

				// console.log("LIST", list, "CLIENT_ID", resp.profile.client_id)
				return list.includes(Number(resp.profile.client_id))
			})()
		}
		// console.log(resp)
		setAuthorizedMarketplace(resp)
	}

	const setTabHandler = (type) => {
		setTab(type)
	}

	const getSellerVendorTable = async () => {
		setTableLoading(true)

		let query1 = "GET_SELLER_VENDOR_TABLE_1", params1 = [
			authorizedMarketPlace.brand_marketplace.id,
			authorizedMarketPlace.brand_int_id,
			neonUser.agency_id,
			tab
		];

		if (neonUser.role == "admin") {
			query1 = "GET_SELLER_VENDOR_TABLE_1_ADMIN";
			params1 = [
				authorizedMarketPlace.brand_marketplace.id,
				authorizedMarketPlace.brand_int_id,
				tab
			]
		}

		let resp = await fetchDataV2(query1, params1, "/neon-query-v2")

		let query2 = "GET_SELLER_VENDOR_TABLE_2", params2 = [resp.map(x => x.client_profile_id)]
		let resp2 = [];
		if (resp.length > 0) {
			resp2 = await fetchDataV2(query2, params2, "/neon-market-v2")
		}

		resp = resp.map(x => ({
			...x,
			profile: resp2.filter(xx => xx.profile_id == x.client_profile_id)[0] || {}
		})).map(x => ({
			...x,
			auth_error: clientAuthList.filter(xx => !xx.status).map(xx => xx.client_info_id).includes(Number(x.profile.client_id))
		}))

		setSellerVendorTable(resp)
		setTableLoading(false)
	}

	const getSellerVendorList = async () => {
		setLoading(true)
		setSellerVendorList([])

		if (!authorizedMarketPlace?.profile) return;

		let query1 = "GET_SELLER_VENDOR_LIST_1", params1 = [neonUser.agency_id]
		let am = await fetchDataV2(query1, params1, "/neon-query-v2")

		let query2 = "GET_SELLER_VENDOR_LIST_2", params2 = [neonUser.agency_id, authorizedMarketPlace.marketPlace.id]

		if (tab == 'dsp') {
			query2 = "GET_SELLER_VENDOR_LIST_2_DSP";
			params2 = [neonUser.agency_id];
		}

		let resp = await fetchDataV2(query2, params2, "/neon-query-v2")

		setLoading(false)
		setSellerVendorList(resp)
		return
	}

	const cancelSelectSellerVendor = () => {
		setSelectedSellerVendor("")
		setAdType("")
	}

	const createAuthorizedMarketplace = async () => {
		let selectedProfile = sellerVendorList.filter(x => x.profile_id == selectedSellerVendor.profile_id)[0]

		setErrorMessage("")
		setLoading(true)

		if (!("profile_id" in selectedSellerVendor)) {
			setErrorMessage("You must select a seller profile.")
			setLoading(false)
			return;
		}

		let query1 = "CREATE_AUTHORIZED_MARKETPLACE_1", params1 = [
			authorizedMarketPlace.brand_marketplace.id,
			adType,
			selectedSellerVendor.profile_id,
			selectedProfile.client_id,
			authorizedMarketPlace.brand_int_id,
			tab,
			neonUser.agency_id,
		]

		let resp = await fetchDataV2(query1, params1, "/neon-query-v2")

		if (!resp) {
			setLoading(false)
			setErrorMessage("Error creating authorized marketplace profile.")
			return
		}

		let query2 = "CREATE_AUTHORIZED_MARKETPLACE_2", params2 = [selectedProfile.profile_id]
		await fetchDataV2(query2, params2, "/neon-market-v2")

		setLoading(false)
		cancelSelectSellerVendor()
		await getSellerVendorTable()
		await getSellerVendorList()
		return
	}

	const deleteAuthorizedMarketplace = async (x) => {
		setToDeleteProfile(x.id)
		setPopupSidebarType("delete_profile")
		setSideBarTitle("Delete Profile")
		getSellerVendorList()
		offCanvas.show()
		return
	}

	useEffect(() => {
		if (!!neonUser.user_id && clientAuthList.length == 0) {
			(async () => {
				await getAgencyClients()
				setClientAuthListLoaded(true)
			})()
		}
	}, [neonUser])

	useEffect(() => {
		if (clientAuthList.length > 0) setClientAuthListLoaded(true)
	}, [clientAuthList])

	useEffect(() => {
		if (sellerVendorList.length == 0 && authorizedMarketPlace.profile) getSellerVendorList();
	}, [authorizedMarketPlace])

	useEffect(() => {
		if (adType != "") getSellerVendorList()
	}, [adType])

	useEffect(() => {
		if (neonUser.user_id && authorizedMarketPlace.brand_int_id) getSellerVendorTable();
	}, [authorizedMarketPlace, neonUser])

	useEffect(() => {
		if (reloadProfileList) {
			getSellerVendorTable()
			setReloadProfileList(false)
		}
	}, [reloadProfileList])

	useEffect(() => {
		setSellerVendorList([])
		setSelectedSellerVendor("")
		setAdType("")
		if (neonUser.user_id && authorizedMarketPlace.brand_int_id) getSellerVendorTable();
		if (authorizedMarketPlace.profile) getSellerVendorList();
	}, [tab])

	useEffect(() => {
		if (neonUser.id && id && marketplaceList.length > 0 && clientAuthListLoaded) getAuthorizedMarketplace()
	}, [id, neonUser, marketplaceList, clientAuthListLoaded])

	useEffect(() => {
		if (neonUser.user_id && authorizedMarketPlace.brand_entity_id) {
			userOwnsBrand(neonUser, authorizedMarketPlace)
		}
	}, [neonUser, authorizedMarketPlace])

	useEffect(() => {
		if (neonUser?.user_id && marketplaceList.length > 0) {
			(async () => {
				await getAgencyClients()
				setAgencyLoaded(true)
			})()
		}
	}, [neonUser, marketplaceList])

	useEffect(() => {
		if (agencyLoaded) {
			(async () => {
				await getBrands()
			})()
		}
	}, [agencyLoaded, adsProfileIdsLoaded])

	useEffect(() => {
		if (loading) disposeAllTooltip()
	}, [loading])

	useEffect(() => {
		if (neonUser?.user_id && marketplaceList.length == 0) getMarketPlace();
	}, [neonUser])

	if (authorizedMarketPlace.brand_int_id) return (
		<div style={{ maxWidth: 1600 }}>
			<div className={"d-flex flex-column gap-2 " + (ww < 400 ? "px-2 pt-4" : "p-4")}>
				<div className={'d-flex gap-1 justify-content-between'}>
					<div className="d-flex gap-2 align-self-center" onClick={goBack}>
						<UiButton3 submit={null} />
						<p className="mb-0 align-self-center fs-4 text-capitalize">{authorizedMarketPlace.brand} {'>'} {authorizedMarketPlace.marketPlace.country}</p>
					</div>
					<BrandAuthStatus type="profile" />
				</div>

				{errorMessage != "" && <p className='poppins text-danger text-bold mb-0'>{errorMessage}</p>}
				<p className="poppins fw-bold mb-0">
					{authorizedMarketPlace.account_type == "seller" ?
						"Seller Central"
						:
						authorizedMarketPlace.account_type == "vendor" ?
							"Vendor Central"
							:
							authorizedMarketPlace.account_type != "ads" ?
								"Authenticate"
								:
								""
					}
				</p>

				{authorizedMarketPlace.account_type != "ads" ?
					<div className="table-responsive">
						<table className="brand-table">
							<tbody>
								<tr>
									{authorizedMarketPlace.profile.sellerId &&
										<td className="p-3 text-start">
											<p className="poppins fw-semibold mb-0" style={{ color: "#650260" }}>DATE CONNECTED</p>
											<span className="text-secondary">{moment(authorizedMarketPlace.created).format("MMM DD, YYYY")}</span>
										</td>
									}
									{authorizedMarketPlace.profile.sellerId &&
										<td hidden={!authorizedMarketPlace.profile} className="middle-row-td p-3 text-start">
											<p className="poppins mb-0 fw-semibold" style={{ color: "#650260" }}>SELLER ID</p>
											{authorizedMarketPlace.profile && <span className="text-secondary">{authorizedMarketPlace.profile.sellerId}</span>}
										</td>
									}
									{authorizedMarketPlace.profile.sellerId ?
										<td className="middle-row-td p-3 text-start">
											<p className="poppins mb-0 fw-semibold" style={{ color: "#650260" }}>STATUS</p>
											{
												// !!authorizedMarketPlace?.profile?.profile_id && !authorizedMarketPlace?.auth_error ?
												!!authorizedMarketPlace?.profile?.profile_id ?
													<span className="text-success">Connected</span>
													:
													<div className='d-flex gap-1'>
														<span className="text-danger">Issue</span>
														<UiTooltip title={"The previously authenticated "
															+ (authorizedMarketPlace.account_type == "seller" ?
																"Seller Central"
																:
																authorizedMarketPlace.account_type == "vendor" ?
																	"Vendor Central"
																	:
																	"") + " account is no longer connected. Please reauthenticate using the link to the right."}>
															<i className="bi bi-info-circle-fill text-danger"></i>
														</UiTooltip>
													</div>
											}
										</td>
										:
										null
									}
									{
										!!authorizedMarketPlace.profile.profile_id
											// && !authorizedMarketPlace.auth_error 
											?
											null
											:
											<td className="middle-row-td p-3">
												<div>
													<p className="text-start poppins mb-0 fw-semibold" style={{ color: "#650260" }}>AUTHORIZATION LINK</p>
													<div className="d-flex gap-1">
														<BrandAuthViewLink
															central={true}
															seller_vendor={null}
															tab={null}
															ads={null}
															imgsrc={null}
															authorizedMarketPlace={authorizedMarketPlace}
															css={null}
															className={"align-self-center"} />
														<div style={{ width: 20, height: 20 }}>
															<img src={baseUrl + "/src/brand-on.png"} style={{ width: "100%", height: "100%" }} />
														</div>
													</div>
												</div>
											</td>
									}
								</tr>
							</tbody>
						</table>
					</div>
					:
					null
				}

				{authorizedMarketPlace.ads_management ?
					<>
						<p className="poppins fw-bold mb-0">Ads</p>
						<div className="container2" style={{ minHeight: 200 }}>
							<div className="w-100 d-flex gap-1" style={{ borderBottom: "2px solid #ff9933", padding: "0px 25px" }}>
								<div style={{ cursor: "pointer" }} onClick={() => setTabHandler('ppc')} className={"d-flex justify-content-center " + (tab == 'ppc' ? "tab-on" : "tab-off")}>
									<p className="poppins mb-0 align-self-center px-2">Sponsored</p>
								</div>
								<div style={{ cursor: "pointer" }} onClick={() => setTabHandler('dsp')} className={"d-flex justify-content-center " + (tab == 'dsp' ? "tab-on" : "tab-off")}>
									<p className="poppins mb-0 align-self-center">DSP</p>
								</div>
							</div>

							<div className="container1 flex-column gap-2">
								<div className="table-responsive">
									<table className="brand-table">
										<thead>
											<tr>
												{adType != "" ?
													<th colSpan={2} className="middle-row-th">Link an Account</th>
													:
													<>
														<th className="">Account Name</th>
														<th className="middle-row-th">{tab == 'dsp' ? 'Advertiser ID' : 'Profile/Entity ID'}</th>
														<th className="middle-row-th">Profile Type</th>
														<th className="middle-row-th">Status</th>
													</>
												}
												<th className="middle-row-th">Action</th>
											</tr>
										</thead>
										<tbody>
											{!tableLoading && sellerVendorTable.map(x => (
												<tr key={x.id}>
													<td>{x.profile.sellerName}</td>
													<td className="middle-row-td">
														{!x.profile.adsEntityId || x.profile.adsEntityId == 'NULL' ?
															tab == 'ppc' ? x.profile.profileId : x.profile.advertiser_id
															:
															x.profile.adsEntityId}
													</td>
													<td className='text-capitalize middle-row-td'>
														{['seller', 'vendor'].includes(x.profile.profile_type) ? 'Sponsored' : (x.profile.profile_type || "").toUpperCase()}
													</td>
													<td className="middle-row-td">
														<BrandAuthViewStatus x={x} tab={tab} />
													</td>
													<td className="middle-row-td">
														<div className="d-flex gap-3 justify-content-center">
															{tableLoading ?
																<UiSpinner />
																:
																<UiTooltip title="Remove">
																	<div
																		onClick={() => deleteAuthorizedMarketplace(x)}
																		style={{ width: 20, height: 20, cursor: "pointer" }}>
																		<img src={baseUrl + "/src/delete.png"} style={{ width: "100%", height: "100%" }} />
																	</div>
																</UiTooltip>
															}
														</div>
													</td>
												</tr>
											))}
											{!tableLoading && sellerVendorTable.length == 0 && (
												<tr>
													<td colSpan={5}>
														<span className='poppins text-secondary'>{`Select ${tab == 'ppc' ? "an Ads" : "a DSP"} Profile below (or Authenticate a new Ads Account if missing) then click 'Add'.`}</span>
													</td>
												</tr>
											)}
											{tableLoading &&
												<tr>
													<td colSpan={5}><UiSpinner /></td>
												</tr>
											}
											<tr style={{ backgroundColor: "#650260" }}>
												<td>
													<div className='d-flex justify-content-center gap-3 my-2'>
														<div className='align-self-center' style={{ cursor: "pointer" }}>
															{loading ?
																<UiSpinner color="white" />
																:
																<UiTooltip title="Refresh Active Ads Profiles">
																	<i onClick={updateSellerVendor} className="bi bi-arrow-clockwise text-white h2 mb-0"></i>
																</UiTooltip>
															}
														</div>
														<div className="d-flex gap-1 dropup-center" style={{ position: 'static' }}>
															<div className="flex-grow-1" style={{ maxWidth: "250px" }} data-bs-toggle="dropdown" aria-expanded="false">
																{!!selectedSellerVendor ?
																	<UiInput1 value={selectedSellerVendor.sellerName} readOnly={true} dropdown={true} userChangeHandler={null} />
																	:
																	<UiInput1 value={tab == 'ppc' ? 'Select Ads Profile' : 'Select DSP Account'} readOnly={true} dropdown={true} userChangeHandler={null} />
																}
															</div>
															<div className="dropdown-menu">
																<div className="px-2">
																	<input type="text" value={search} onChange={(e) => setSearch(e.target.value)} className="form-control form-control-sm mb-1 poppins" placeholder="search..." />
																</div>
																<div className="px-2 d-flex flex-column gap-1" style={{ maxWidth: 300, maxHeight: 200, overflowY: 'auto' }}>
																	{sellerVendorList.length > 0 &&
																		sellerVendorList
																			.filter(x => {
																				if (tab == 'dsp') return true
																				return x.countryCode == authorizedMarketPlace.marketPlace.countrycode
																			})
																			.filter(x => {
																				return (x?.sellerName || "").toLowerCase().includes(search.toLowerCase()) ||
																					(x?.adsEntityId || "").toLowerCase().includes(search.toLowerCase());
																			})
																			.map((x, i) => (
																				<div key={i} style={{ cursor: "pointer" }} className="d-flex flex-column gap-2 dropdown-item lh-1" onClick={() => setSelectedSellerVendor(x)}>
																					<p title={x.sellerName} className='mb-0 text-truncate fw-bold'>{x.sellerName}</p>
																					<small title={x.sellerName} className='mb-0'>{x.profile_type == 'dsp' ? x.adsEntityId : x.profileId}</small>
																				</div>
																			))
																	}
																</div>
															</div>
														</div>
													</div>
												</td>
												<td rowSpan={3} colSpan={3}>
													<div className="d-flex gap-2 justify-content-between py-2">
														<div className='d-flex gap-2 justify-content-evenly w-100'>
															<span className="poppins align-self-center text-white">or</span>
															<BrandAuthViewLink
																seller_vendor={true}
																tab={tab}
																ads={true}
																imgsrc={null}
																authorizedMarketPlace={authorizedMarketPlace}
																sellerVendorTable={sellerVendorTable}
																css={null}
																className={"poppins align-self-center text-white"} />
															<div></div>
														</div>
													</div>
												</td>
												<td className="middle-row-td">
													{loading ?
														<UiSpinner />
														:
														<div className="d-flex gap-3 justify-content-center">
															{selectedSellerVendor &&
																<div
																	className='px-3'
																	onClick={() => createAuthorizedMarketplace()}
																	style={{ cursor: "pointer", backgroundColor: "white", borderRadius: "25px", color: "#650260", padding: "5px 10px" }}>
																	Add
																</div>
															}
														</div>
													}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</>
					:
					null
				}
			</div>
		</div>
	)
	else return (
		<div className="d-flex justify-content-center" style={{ height: hh - 80 }}>
			<UiSpinner />
		</div>
	)
}

export default BrandAuthView